module.exports = __webpack_public_path__ + "static/img/zoom_btn6.7adb806.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cec2022/zoom_btn6.png
// module id = Arje
// module chunks = 4